// deepcontext-63k8.3 — the configured self-hosted servers for the job form's
// model picker. Fetched only when the current user may see the picker; a failed
// fetch leaves the list empty (the picker then offers just Gemini).
import { useEffect, useState } from "react";
import { scheduledJobsApi } from "./api";
import type { LocalModelServer } from "./types";

export function useLocalModels(enabled: boolean): LocalModelServer[] {
  const [servers, setServers] = useState<LocalModelServer[]>([]);

  useEffect(() => {
    if (!enabled) {
      setServers([]);
      return;
    }
    let cancelled = false;
    scheduledJobsApi
      .getLocalModels()
      .then((list) => {
        if (!cancelled) setServers(Array.isArray(list) ? list : []);
      })
      .catch((err) => {
        console.error("Failed to load local models:", err);
      });
    return () => {
      cancelled = true;
    };
  }, [enabled]);

  return servers;
}
